export enum I18nNamespace {
  AUTH = 'auth',
  COMMON = 'common',
  PAGE = 'page',
  WARNING = 'warning',
}

export enum Languages {
  ENGLISH = 'en',
  VIETNAM = 'vi',
}

export const I18N_LOCAL_STORAGE_KEY = 'i18nextLng';
